export type CropAndBrandAvailability7 = {
	CropKey: string;
	CropName: string;
	CropId: string; 
	Brand: string;
	BrandId: string; 
	Series: Record<string, SeriesAvailability7>;
};

export type SeriesAvailability7 = {
	SeriesId: string; 
	SeriesName: string;
	RelativeMaturity: string;
	Availability: AvailabilityIndicator;
	NationalPositioningStrength: string;
	NationalPositioningConsideration: string;
	Attributes: Record<string, AttributeRating7>;
	Hybrids: Record<string, HybridAvailability7>;
};

export enum AvailabilityIndicator {
	Unknown = 0,
	Red,
	Yellow,
	Green,
	None,
}

export type Sku = {
	Availability: AvailabilityIndicator;
	Id: string;
	ProductId: string;
	Packaging: string;
	Treatment: string;
	TreatmentCode: string;
	Product: string;
	VarietySku: string;
	MaterialSku: string;
	LargeVariation: boolean;
};

export type AttributeRating7 = {
	AttributeId: string; 
	Value?: string; 
	NormalizedValue?: number;
};

export type HybridAvailability7 = {
	HybridId: string; 
	HybridName: string;
	TraitId: string; 
	TraitName: string;
	TraitFullName: string;
	Availability: AvailabilityIndicator;
	Treatments: Record<string, TreatmentAvailability7>; 
};

export type TreatmentAvailability7 = {
	TreatmentName: string;
	TreatmentCode: string;
	Availability: AvailabilityIndicator;
	PricePerUnit?: number;
	PricingUnit?: PricingUnits;
	MaterialAvailability: MaterialAvailability7[]; 
};

export type PricingUnits = 'Bag' | 'Acre';

export type PricingData = {
	PricePerUnit: number;
	PricingUnit: PricingUnits;
};

export type MaterialAvailability7 = {
	Product: string;
	Packaging: Packaging;
	Availability: AvailabilityIndicator;
};

export enum Packaging {
	Unknown = 0,
	TO,
	PB,
	QB,
	TB
}